import request from '@/utils/http'
import { SRM, SRM_FILE } from '../../constant/constant.js'
import store from '@/store/index'

const tenantCode = store.state.currentTenant.tenantCode

// 全部供应商列表
export const getAllSupplierList = params => {
    return request({
        url: `${SRM}/supplierInfo/query/condition`,
        method: 'get',
        params: params,
    })
}
// 全部待处理供应商列表
export const getAwaitSupplierList = params => {
    return request({
        url: `${SRM}/supplierInfo/query/await`,
        method: 'get',
        params: params,
    })
}
// 新增弹框请求选择供应商类型
export const chooseSupplierType = params => {
    return request({
        url: `${SRM}/manage/chooseSupplierType`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 新增弹框选择业务类型
export const chooseBusinessType = params => {
    return request({
        url: `${SRM}/manage/chooseBusinessType`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 新增弹框选择业务类型 - 业务类型多选
export const supplierTypeConfigAssociation = params => {
    return request({
        url: `${SRM}/manage/supplierTypeConfigAssociation`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 新增弹框选择合作方式或者运输方式
export const chooseTransport = params => {
    return request({
        url: `${SRM}/manage/chooseTransport`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 新增弹框确定提交
export const confirmSupplierType = params => {
    return request({
        url: `${SRM}/manage/batchConfirmSupplierBusiness`,
        method: 'put',
        data: params,
    })
}
// 判断是否符合新服务申请资格
export const queryNewService = params => {
    return request({
        url: `${SRM}/addBusinessQualification/${params.id}/${params.tenantCode}`,
        method: 'get',
    })
}
// 判断是否符合退出申请
export const queryQuitService = params => {
    return request({
        url: `${SRM}/quit/check`,
        method: 'get',
        params,
    })
}
// 判断是否符合拉黑申请
export const queryBlackService = params => {
    return request({
        url: `${SRM}/black/check`,
        method: 'get',
        params,
    })
}
// 获取退出申请相关信息
export const showQuitInfoService = params => {
    return request({
        url: `${SRM}/quit/reShowQuitInfo`,
        method: 'get',
        params: params,
    })
}
// 获取拉黑申请相关信息
export const showBlackInfoService = params => {
    return request({
        url: `${SRM}/quit/reShowBlackInfo`,
        method: 'get',
        params: params,
    })
}
// 验证身份证
export const checkIdCode = params => {
    return request({
        url: `${SRM}/manage/checkIdCard`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}
// 导出列表
export const exportListData = params => {
    return request({
        url: `${SRM_FILE}/exportSupplierInfo`,
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

// 查询供应商合同
export const getContractReq = params => {
    return request({
        url: params.businessType
            ? `${SRM}/contract/${params.supplierCode}/${params.businessType}`
            : `${SRM}/contract/${params.supplierCode}`,
        method: 'get',
    })
}

// 保存供应商退出信息
export const saveQuitSupplier = params => {
    return request({
        url: `${SRM}/quit`,
        method: 'post',
        data: params,
    })
}

// 查询供应商退出信息
export const getSupplierQuitReq = params => {
    return request({
        // url: `${SRM}/quit/${params.formInstanceId}`,
        url: `${SRM}/quitRecordQuery`,
        method: 'get',
        params,
    })
}

// 供应商退出MIP审批
export const createQuitDraftProcess = params => {
    return request({
        url: `${SRM}/quit/createDraftProcess`,
        method: 'post',
        data: params,
    })
}

// 保存供应商拉黑信息
export const saveBlackSupplier = params => {
    return request({
        url: `${SRM}/black`,
        method: 'post',
        data: params,
    })
}

// 查询供应商拉黑信息
export const getSupplierBlackReq = params => {
    return request({
        url: `${SRM}/blackRecordQuery`,
        method: 'get',
        params,
    })
}

// 供应商拉黑MIP审批
export const createBlackDraftProcess = params => {
    return request({
        url: `${SRM}/black/createDraftProcess`,
        method: 'post',
        data: params,
    })
}

// 供应商引入确认
export const confirmIntrofuce = params => {
    return request({
        url: `${SRM}/manage/saveRepeatSupplierInfo`,
        method: 'post',
        data: {
            ...params,
            tenantCode: tenantCode,
        },
    })
}

// 同步承运商资源池
export const manualSyn = data => {
    return request({
        url: `${SRM}/transport/pool/route/supplier/relation/manualSyn`,
        method: 'post',
        data,
    })
}

// 同步到大物流
export const handworkSupplierDataSyncJob = () => {
    return request({
        url: `${SRM}/handworkSupplierDataSyncJob`,
        method: 'get',
    })
}

// 明细导出
export const exportSupplierDetailInfo = data => {
    return request({
        url: `${SRM_FILE}/exportSupplierDetailInfo`,
        method: 'post',
        data,
    })
}
